import { PureComponent } from 'react';
import { connect } from 'react-redux';
import { change as changeForm } from 'redux-form';
import PropTypes from 'prop-types';
import { SelectControl } from 'components/forms/Select';
import { maybeLoadModelSubType } from 'components/forms/filters/vehicle/actions';
import {
  VEHICLE_NAME,
  MAKE_NAME,
  SUB_TYPE_NAME,
  MODEL_NAME,
} from 'components/searchAds/constants';

class MakeControl extends PureComponent {
  static propTypes = {
    changeForm: PropTypes.func.isRequired,
    formName: PropTypes.string,
    input: PropTypes.object,
    maybeLoadModelSubType: PropTypes.func,
    maybeLoadSubType: PropTypes.func,
    fieldIndex: PropTypes.number,
  };

  handleChange = async (value) => {
    const { changeForm, fieldIndex, formName, input, maybeLoadModelSubType } =
      this.props;

    input.onChange(value);

    await changeForm(
      formName,
      `${VEHICLE_NAME}.${fieldIndex}.${MODEL_NAME}`,
      null,
    );

    await changeForm(
      formName,
      `${VEHICLE_NAME}.${fieldIndex}.${SUB_TYPE_NAME}`,
      null,
    );

    await maybeLoadModelSubType(value);
  };

  render() {
    const { input } = this.props;

    return (
      <SelectControl
        {...this.props}
        qaSelector={MAKE_NAME}
        input={{
          ...input,
          onChange: this.handleChange,
        }}
      />
    );
  }
}

export default connect(null, { maybeLoadModelSubType, changeForm })(
  MakeControl,
);
